import { Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'ibex-checkbox',
  templateUrl: './ibex-checkbox.component.html',
  styleUrls: ['./ibex-checkbox.component.scss'],
  standalone: false
})

export class IbexCheckboxComponent {
  @Input() public id: string;
  @Input() title: string;
  @Input() public checked: boolean;
  @Input() public disabled: boolean;
  @Input() tooltip: string;
  @Input() textLeft: boolean;
  @HostBinding('class.left') left = false;
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() click: EventEmitter<any> = new EventEmitter();
  @ViewChild('checkbox') checkbox: ElementRef;

  constructor(public elementRef: ElementRef) {}

  onChange(event: any) {
    this.left = this.textLeft;
    event.stopPropagation();
    event['val'] = event.target.checked;
    this.change.emit(event);
  }

  onClick(event: any) {
    event.stopPropagation();
    if (event?.target.tagName !== 'INPUT') {
      const currentVal = this.checkbox.nativeElement.checked;
      this.checkbox.nativeElement.checked = !currentVal;
    }
    event['val'] = this.checkbox.nativeElement.checked;
    this.checked = this.checkbox.nativeElement.checked;
    event.senderId = this.id;
    this.click.emit(event);
  }

  public select() {
    this.checkbox.nativeElement.checked = true;
  }

  public unselect() {
    this.checkbox.nativeElement.checked = false;
  }
}
